import { BetSlipHelper } from "app/helpers/betSlipHelper";
import type {
  EventRunnerType,
  EventType,
  RunnerAggregatedPriceType,
} from "app/types/eventType";
import { ExchangeRunnerPriceSides } from "app/utils/const";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import DisplayExchangeMarketRunnerPriceArrow from "../DisplayExchangeMarketRunnerPriceArrow/DisplayExchangeMarketRunnerPriceArrow";
import "./DisplayExchangeMarketRunnerPriceChange.scss";
function DisplayExchangeMarketRunnerPriceChange(props: {
  price: RunnerAggregatedPriceType;
  index?: number;
  event: EventType;
  runner: EventRunnerType;
  addBetSlip: Function;
}) {
  const [exchangePrice, setExchangePrice] =
    useState<RunnerAggregatedPriceType>();
  const prevPrice: any = usePrevious(exchangePrice);
  const [displayFlash, setDisplayFlash] = useState(false);

  useEffect(() => {
    return setExchangePrice(props.price);
  }, []);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  // removed logic that updates exchangePrice when props.price changes
  // so now the availableAmount and decimalOdds change independently

  useEffect(() => {
    if (props.price !== exchangePrice) {
      setExchangePrice(props.price);
    }
  }, [props.price]);

  useEffect(() => {
    if (
      prevPrice &&
      prevPrice.decimalOdds !== undefined &&
      exchangePrice !== undefined
    ) {
      if (prevPrice.decimalOdds !== exchangePrice.decimalOdds) {
        if (prevPrice.decimalOdds < exchangePrice.decimalOdds) {
          setExchangePrice({ ...exchangePrice, direction: "up" });
          setDisplayFlash(true);
        } else if (prevPrice.decimalOdds > exchangePrice.decimalOdds) {
          setExchangePrice({ ...exchangePrice, direction: "down" });
          setDisplayFlash(true);
        } else {
          setExchangePrice({ ...exchangePrice, direction: "" });
          setDisplayFlash(false);
        }
      }
    }
  }, [exchangePrice]);

  useEffect(() => {
    if (displayFlash) {
      setTimeout(() => {
        setDisplayFlash(false);
      }, 1500);
    }
  }, [displayFlash]);

  const addToExcangeBetslip = (exchangePrice: RunnerAggregatedPriceType) => {
    const { event, runner, addBetSlip } = props;
    let betSlip = BetSlipHelper.prepareBetSlip(event, runner);
    // update betslip with Exchange data for bet
    betSlip = {
      ...betSlip,
      isExchange: runner.isExchange,
      exchangePrice: exchangePrice,
    };
    addBetSlip(betSlip);
  };

  if (exchangePrice === undefined) {
    return <span className={`blank__price`}>&nbsp;</span>;
  }

  return (
    <span className={`flash`}>
      <span
        className={`
      exchange__runner-price 
      ${exchangePrice.side?.toLowerCase()} 
      ${displayFlash ? "orange-flash" : ""}
      ${
        exchangePrice.side === ExchangeRunnerPriceSides.BACK &&
        props.index === 2
          ? "back__best-odds"
          : ""
      }
      ${
        exchangePrice.side === ExchangeRunnerPriceSides.LAY && props.index === 3
          ? "lay__best-odds"
          : ""
      }
    `}
        onClick={() => addToExcangeBetslip(exchangePrice)}
      >
        <DisplayExchangeMarketRunnerPriceArrow price={exchangePrice} />
        <span>
          {exchangePrice.side === ExchangeRunnerPriceSides.BLANK
            ? ""
            : exchangePrice.decimalOdds}
        </span>
        <span>
          {" "}
          {exchangePrice.side === ExchangeRunnerPriceSides.BLANK
            ? ""
            : exchangePrice.availableAmount}
        </span>
      </span>
    </span>
  );
}

const mapDispatchToProps = dispatch => ({
  addBetSlip: (betSlip: EventType) =>
    dispatch.betSlipListModel.addBetSlip(betSlip),
});

export default connect(
  null,
  mapDispatchToProps
)(DisplayExchangeMarketRunnerPriceChange);
